import LayoutPresetsService from './LayoutPresetsService';

export default LayoutPresetsService;